import React, {Component} from 'react'
import icon_search from '../img/icon_search.png'
import {connect} from 'react-redux'
import moment from 'moment'
import axios from 'axios'
import './index.css'
import {Input, Radio, DatePicker, List, message, Modal, Button, Descriptions, Form, Select} from 'antd';
import {
    getOrderDownload, getOrderProduction_text, getOrderUpload, getOrderData, putMicrowaveOder,
    getProductInspectionOrder, getTechnologyInspectionOrder, getSimulationData, getMicrowaveData
} from '../actions';
import ProduceListItem from './ProduceListItem'
import DownloadListItem from './DownloadListItem'
import UploadListItem from './UploadListItem'
import SimulationListItem from './SimulationListItem'
import TecTestListItem from './TecTestListItem'
import ProduceTestListItem from './ProduceTestListItem'
import MicrowaveListItem from "./MicrowaveListItem";
import TextArea from "antd/lib/input/TextArea";

const {RangePicker} = DatePicker;

const defaultState = {
    timeRadio: 3,
    dataList: [],
    satStartDate: '',
    satEndDate: '',
    parentOrderID: '',
    currentPage: 1,
    totalPage: '',
    showFlag: false,
    expendItem: '',
    isLoading: false,
    listLoading: true,
    title: '下载订单',
    openRequireModal: false,
    orderType: '',
}


class UserOrder extends Component {
    constructor(props) {
        super(props)
        this.state = defaultState
        this.microwaveFormRef = React.createRef()
    }

    componentDidMount() {
        // console.log('用户信息:', this.props.user);
        let timer1 = setInterval(() => {
            if (this.props.user.userId) {
                this.getOrderData()
                clearInterval(timer1)
            }
        }, 200)
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            console.log(this.props.location.pathname, this.state.currentPage)
            this.setState(defaultState, () => this.getOrderData())
        }
    }

    setExpendItem = id => {
        console.log(this.state.dataList)
        if (this.state.expendItem === id) {
            this.setState({
                expendItem: null
            })
        } else {
            this.setState({
                expendItem: id
            })
        }

    }

    getOrderData = async (parentOrderID = this.state.parentOrderID, page = this.state.currentPage) => {
        const {satStartDate, satEndDate, currentPage} = this.state
        // console.log("((((((((((((((((((((((((((((((((((((((((((((")
        // console.log('检查时间格式是否异常', satStartDate, satEndDate)
        // console.log(")))))))))))))))))))))))))))))))))))))))))))")
        const {userName, userId, token} = this.props.user

        let res
        let total, records
        let type = this.props.location.pathname.replace('/userCenter/', '')
        try {
            switch (type) {
                case "DownLoadOrder":
                    this.setState({title: '下载订单'})
                    res = await getOrderDownload(currentPage, 10, userId, parentOrderID, satStartDate, satEndDate, token);
                    total = res.total
                    records = res.records
                    break;
                case "UploadOrder":
                    this.setState({title: '上传订单'})
                    res = await getOrderUpload(currentPage, 10, userId, parentOrderID, satStartDate, satEndDate);
                    total = res.total
                    records = res.records
                    break;
                case "ProduceOrder":
                    this.setState({title: '生产订单'})
                    res = await getOrderData(currentPage, 10, userId, parentOrderID, satStartDate, satEndDate, userName);
                    total = res.total
                    records = res.rows
                    break;
                case "FutureOrder":
                    this.setState({title: '未来订单'})
                    res = await getOrderProduction_text(currentPage, 10, userId, parentOrderID, satStartDate, satEndDate, userName);
                    // console.log('来到未来订单获取数据:',res)
                    total = res.total
                    // records = res.records
                    records = res.rows
                    break;
                case "SimulationOrder":
                    this.setState({title: '仿真订单'})
                    res = await getSimulationData(currentPage, 10, userId, parentOrderID, satStartDate, satEndDate);
                    total = res.total
                    records = res.data
                    break;
                case "ProduceTestOrder":
                    this.setState({title: '产品检验订单'})
                    res = await getProductInspectionOrder(currentPage, 10, userId, parentOrderID, satStartDate, satEndDate);
                    total = res.total
                    records = res.list
                    break;
                case "TecTestOrder":
                    this.setState({title: '技术检验订单'})
                    res = await getTechnologyInspectionOrder(currentPage, 10, userId, parentOrderID, satStartDate, satEndDate);
                    total = res.total
                    records = res.data
                    break;
                case "MicrowaveOrder":
                    this.setState({title: '光学微波仿真订单'})
                    res = await getMicrowaveData(currentPage, 10, userId, parentOrderID, satStartDate, satEndDate);
                    total = res.total
                    records = res.data
                    break;
                default:
                    break;
            }
            // console.log('检查微波仿真数据:',records);
            this.setState({totalPage: total, dataList: records, listLoading: false})
        } catch (error) {
            message.error('获取订单失败')
            this.setState({listLoading: false})
        }

    }


    onTimeRadioChange = (e) => {
        console.log('radio checked', e.target.value);
        let flag = false
        let endTime = moment()
        let startTime
        switch (e.target.value) {
            case 1:
                startTime = moment().subtract(1, 'months')
                break;
            case 2:
                startTime = moment().subtract(1, 'years')
                break;
            case 3:
                startTime = null
                endTime = null
                break;
            case 4:
                flag = true
                break
        }

        this.setState({
            showFlag: flag,
            timeRadio: e.target.value,
            satStartDate: startTime,
            satEndDate: endTime
        }, () => this.getOrderData());
    };

    onSearch = (id) => {
        this.getOrderData(id)
    }

    pushPage = (path, state) => {
        // console.log(this.props.history)
        this.props.history.push(path + `?id=${state}`)
    }

    _renderListItem = (item) => {
        let type = this.props.location.pathname.replace('/userCenter/', '');
        // console.log('检查未来订单数据项:',item);
        const {userName, userId, token} = this.props.user
        switch (type) {
            case "DownLoadOrder":
                // console.log("打印检查下载订单数据项:",item);
                return (
                    <List.Item>
                        <DownloadListItem item={item} setExpend={this.setExpendItem} expendId={this.state.expendItem}
                                          getOrderData={this.getOrderData}></DownloadListItem>
                    </List.Item>
                )
            case "UploadOrder":
                return (
                    <List.Item>
                        <UploadListItem item={item} setExpend={this.setExpendItem} expendId={this.state.expendItem}
                                        getOrderData={this.getOrderData}></UploadListItem>
                    </List.Item>
                )
            case "ProduceOrder":
                return (
                    <List.Item>
                        <ProduceListItem pushPage={this.pushPage} item={item} setExpend={this.setExpendItem}
                                         expendId={this.state.expendItem}
                                         getOrderData={this.getOrderData}></ProduceListItem>
                    </List.Item>
                )
            case "FutureOrder":
                return (
                    <List.Item>
                        <ProduceListItem pushPage={this.pushPage} item={item} setExpend={this.setExpendItem}
                                         expendId={this.state.expendItem}
                                         getOrderData={this.getOrderData}></ProduceListItem>
                    </List.Item>
                )
            case "SimulationOrder":
                // console.log('设置订单类型',type)
                // this.setState({orderType: "SimulationOrder"})
                return (
                    <List.Item>
                        <SimulationListItem item={item} setExpend={this.setExpendItem} expendId={this.state.expendItem}
                                            getOrderData={this.getOrderData}></SimulationListItem>
                    </List.Item>
                )
            case "ProduceTestOrder":
                return (
                    <List.Item>
                        <ProduceTestListItem item={item} setExpend={this.setExpendItem} expendId={this.state.expendItem}
                                             getOrderData={this.getOrderData}></ProduceTestListItem>
                    </List.Item>
                )
            case "TecTestOrder":
                return (
                    <List.Item>
                        <TecTestListItem item={item} setExpend={this.setExpendItem} expendId={this.state.expendItem}
                                         getOrderData={this.getOrderData}></TecTestListItem>
                    </List.Item>
                )
            case "MicrowaveOrder":
                return (
                    <List.Item>
                        <MicrowaveListItem item={item} setExpend={this.setExpendItem} expendId={this.state.expendItem}
                                           getOrderData={this.getOrderData} userId={userId}></MicrowaveListItem>
                    </List.Item>
                )
            default:
                break;
        }

    }
    _onPageChange = page => {
        this.setState({listLoading: true, currentPage: page, dataList: []}, () => {
            this.getOrderData()
        })
    }
    _onTimeChange = (time) => {
        if (time) {
            this.setState({
                satStartDate: time[0],
                satEndDate: time[1],
            }, () => {
                this.getOrderData()
            })
        }
    }

    _onSearchInput = e => {
        this.setState({
            parentOrderID: e.target.value
        })
    }

    _showRequireModal = () => {
        this.setState({openRequireModal: true})
    }

    _submitMicrowaveData = (values) => {
        this.setState({openRequireModal: false})
        const {userId, userName} = this.props.user
        values.userid = userId
        values.applicant = userName
        values.orderstatus = "等待处理"
        // console.log('检查是否存在orderstatus', values);
        putMicrowaveOder(values).then(res => {
                // console.log('仿真订单提交结果userorder',res);
                if (JSON.parse(res.msg).result === '成功') message.success('仿真订单提交成功!')
            }
        )

        // console.log('表单数据', values);
        // console.log(putMicrowaveOder(values));
        this.microwaveFormRef.current.resetFields();
    }

    render() {
        const {timeRadio, dataList, totalPage, parentOrderID, showFlag, listLoading, currentPage, title} = this.state
        // console.log('订单类型',orderType);
        let orderType = this.props.location.pathname.replace('/userCenter/', '')
        const {userName} = this.props.user
        return (
            <>
                <div className='order-header'>
                    <span>{title}</span>
                </div>
                <div className='order-body'>
                    <div className='order-function-zone'>
                        <Input
                            className='order-function-search'
                            suffix={
                                <img src={icon_search} className='search-icon'
                                     onClick={e => this.onSearch(e.target.value)}></img>
                            }
                            placeholder="根据关键词查询相关订单"
                            value={parentOrderID}
                            onChange={e => this._onSearchInput(e)}
                        />
                        {orderType === "MicrowaveOrder" ?
                            <div className="fz-button-box">
                                <Button style={{fontSize: '1.3rem', borderRadius: "3px", height: "100%"}}
                                        onClick={this._showRequireModal} size="small">提交仿真订单</Button>
                            </div> :
                            <></>
                        }
                        <Radio.Group size="small" onChange={this.onTimeRadioChange} value={timeRadio}
                                     className='order-function-radio'>
                            <Radio value={3}>不限时间</Radio>
                            <Radio value={1}>一月内</Radio>
                            <Radio value={2}>一年内</Radio>
                            <Radio value={4}>自定义</Radio>
                        </Radio.Group>
                        <div style={showFlag ? {display: 'block'} : {display: 'none'}}>
                            <RangePicker className='order-function-rangePicker' size='small'
                                         onChange={this._onTimeChange}/>
                        </div>
                    </div>
                    {/* <div className='produce-order-globe'>
                        <Globe></Globe>
                    </div> */}
                    <div className='order-produce-list-body'>
                        <List
                            dataSource={dataList}
                            renderItem={this._renderListItem}
                            split={false}
                            size='small'
                            pagination={{
                                onChange: page => this._onPageChange(page),
                                current: currentPage,
                                pageSize: 10,
                                total: totalPage,
                                showSizeChanger: false
                            }}
                            loading={listLoading}
                        />
                    </div>
                </div>
                <Modal title="需求文档" visible={this.state.openRequireModal}
                       onOk={() => this.microwaveFormRef.current.submit()}
                       onCancel={() => this.setState({openRequireModal: false})}
                       width={800}
                >

                    <Form
                        ref={this.microwaveFormRef}
                        onFinish={this._submitMicrowaveData}
                        labelCol={{span: 4}}
                        wrapperCol={{span: 14}}
                        initialValues={{
                            orderType: 'micro' // 这里设置默认值
                        }}
                    >
                        <Form.Item
                            name="applicant"
                            label="申请人"
                        >{userName}</Form.Item>
                        <Form.Item
                            name="company"
                            required={true}
                            label={'申请单位部门'}
                            rules={[
                                {
                                    required: true,
                                    message: '请输入申请单位部门！',
                                },
                            ]}
                        >
                            <Input/>
                        </Form.Item>
                        <Form.Item
                            name="orderType"
                            required={true}
                            label={'仿真类型'}
                            rules={[
                                {
                                    required: true,
                                    // message: '请输入电话仿真目的！',
                                },
                            ]}
                        >
                            <Select defaultValue="micro"
                                // onChange={}
                                    options={[
                                        {
                                            value: 'micro',
                                            label: '微波仿真订单'
                                        },
                                        {
                                            value: 'optical',
                                            label: '光学仿真订单'
                                        }
                                    ]}>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            name="contactInfo"
                            required={true}
                            label={'联系方式'}
                            rules={[
                                {
                                    required: true,
                                    message: '请输入联系方式！',
                                },
                            ]}
                        >
                            <Input/>
                        </Form.Item>
                        <Form.Item
                            name="intention"
                            required={true}
                            label={'仿真目的'}
                            rules={[
                                {
                                    required: true,
                                    message: '请输入仿真目的！',
                                },
                            ]}
                        >
                            <TextArea/>
                        </Form.Item>
                        <Form.Item
                            name="demand"
                            required={true}
                            label={'仿真要求'}
                            rules={[
                                {
                                    required: true,
                                    message: '请输入仿真要求！',
                                },
                            ]}
                        >
                            <TextArea/>
                        </Form.Item>
                    </Form>
                    {/*<Descriptions column={2} bordered labelStyle={{width: "140px"}}>*/}
                    {/*    <Descriptions.Item label="申请人" span={2}>阿萨德</Descriptions.Item>*/}
                    {/*    <Descriptions.Item label="申请单位部门" span={2}>苏州空天信息研究院</Descriptions.Item>*/}
                    {/*    <Descriptions.Item label="邮箱">123465789@789.com</Descriptions.Item>*/}
                    {/*    <Descriptions.Item label="电话">741852963899</Descriptions.Item>*/}
                    {/*    <Descriptions.Item label="电话仿真目的" span={2}>*/}
                    {/*        申请人简单介绍仿真的目标，例如服务于xxx项目、xxx研究等；*/}
                    {/*        申请人简单介绍仿真的目标，例如服务于xxx项目、xxx研究等；*/}
                    {/*        申请人简单介绍仿真的目标，例如服务于xxx项目、xxx研究等；*/}
                    {/*        申请人简单介绍仿真的目标，例如服务于xxx项目、xxx研究等；*/}
                    {/*    </Descriptions.Item>*/}
                    {/*    <Descriptions.Item label="仿真要求" span={2}>*/}
                    {/*        1.仿真目标与场景要求*/}
                    {/*        2.仿真参数，散射仿真（频率、入射角），仿真成像（波段、带宽、入射角、xxx卫星）*/}
                    {/*        3.如果部分仿真参数文件，可以放在附件中*/}
                    {/*        如果填写参数不全，后续微波测量仿真分系统会联系您，寻求更进一步的要求或者参数。*/}
                    {/*    </Descriptions.Item>*/}
                    {/*</Descriptions>*/}
                </Modal>
            </>
        )
    }
}

const mapState = state => ({
    user: state.userReducer.get('user').toJS(),
})

export default connect(mapState)(UserOrder)
